module.exports = __webpack_public_path__ + "static/media/chip-50.e5768fc2.png";